import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../../../atomic/Buttons/Button';
import Icon from '@material-ui/core/Icon';
import CircularProgress from '@material-ui/core/CircularProgress';
import VideoModal from '../../Modals/VideoPlayModal';

const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: space-around;
  width: 200px;
  height: 100px;
`
const VideoOption = styled.video`
  height: 90%;
  max-width: 90%; 
  flex-shrink: 1;
`
const VideoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  /*height: 100%;*/
  flex: 1 0 auto;
`
const ButtonStyled = styled(Button)`
  position: absolute;
  padding: 0;
  right: 0;
  min-width: 40px;
  max-width: 40px;
  height: 40px;
`
const ButtonOverlay = styled(Button)`
  position: absolute;
  background: rgba(0,0,0,0.1);
  /*width: 100%;
  height: 100%;*/
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 0px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  :hover { 
    background: rgba(0,0,0,0.3);
  }
`
const IconStyled = styled(Icon)`
  color: white;
  opacity: ${props => props.fade === "true" ? 0.8 : 1};
`

const VideoModalStyled = styled(VideoModal)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 75%;
  height: auto;
`

const PlaceholderIconStyled = styled(Icon)`
  font-size: 40px;
  margin-bottom: 8px;
`
const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 160px;
`

class VideoSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
    };
  }

  openModal = () => {
    const { onClick, processing } = this.props;
    if (processing) {
      return;
    }
    if (onClick) {
      onClick();
    }
    this.setState({ modalOpen: true });
  };

  closeModal = () => {
    this.setState({ modalOpen: false });
  }

  handleClose = () => {
    const { onClose } = this.props;
    if(onClose) {
      onClose();
    }
    this.setState({ modalOpen: false });
  };

  render() {
    const {
      onDelete,
      children,
      modalComponent,
      processing,
      thumbnail,
      video,
      ...other
    } = this.props;
    const { modalOpen } = this.state;

    return (
      <Container {...other}>
        <VideoContainer>
          { video ? (
            <>
              <VideoOption src={video} poster={thumbnail} preload="metadata" />
              <ButtonOverlay variant='outlined' onClick={this.openModal}>
                { processing ? (
                  <CircularProgress />
                ) : (
                  <IconStyled fade={"true"}>play_arrow</IconStyled>
                )}
              </ButtonOverlay>
            </>
          ) : (
            <ImageWrapper style={{opacity: 0.3}}>
              <PlaceholderIconStyled>photo</PlaceholderIconStyled>
              No Video
            </ImageWrapper>
          )}
        </VideoContainer>
        {
          onDelete && video &&
          <ButtonStyled variant='contained' color="secondary" onClick={onDelete}>
            <IconStyled>delete_forever</IconStyled>
          </ButtonStyled>
        }
        <VideoModalStyled
          open={modalOpen}
          onBackdropClick={this.closeModal}
          onClose={this.handleClose}
          thumbnail={thumbnail}
          video={video} />
      </Container>
    );
  }
}

VideoSelect.propTypes = {
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  thumbnail: PropTypes.string,
  video: PropTypes.string,
};

VideoSelect.defaultProps = {
  data: [],
  video: {},
};

export default VideoSelect;
